import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../../api';
import { CRUMB_LABEL_KEY, VOZIDLO_DATA } from '../../constants';

export const store = listStoreBuilder({
	name: VOZIDLO_DATA,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {
			type: null as string | null,
			VozidloId: null as number | null,
			VIN: null as number | null,
		},
		mode: null,
		afterRowSelection: () => {},
	},
});
